module.exports = __webpack_public_path__ + "img/icon_arrow-up-right.669a2c3a.svg";